// extracted by mini-css-extract-plugin
export default {"loader":"Loader_loader__+lRPl","loader__spinner":"Loader_loader__spinner__QoLfC","icon":"Loader_icon__4MFnc"};